import * as GETTERS from '@/store/constants/getters.js';
import { ZERO_UUID } from 'commons/constants/parse.js';
import {
    ORIGIN_TWITTER, ORIGIN_INSTAGRAM, TWITTER_UUID, INSTAGRAM_UUID,
} from '@/constants/origin.js';

export const getters = {
    [GETTERS.USER_BY_UUID]: (state) => (uuid) => state.users[uuid],

    [GETTERS.CURRENT_USER_UUID]: (state) => state.current,

    [GETTERS.CURRENT_USER_IS_GLOBAL_ADMIN]: (state) => (state.current ? state.users[state.current].user_privilege === 'global_administrator' : false),

    [GETTERS.USER_COMMENTS]: (state) => (uuid) => state.users[uuid].comments,

    [GETTERS.TOTAL_USER_COMMENTS_BY_UUID]: (state) => (uuid) => state.users[uuid].total_comments,

    [GETTERS.USER_BY_ORIGIN](state, getters) {
        return ({ actor_uuid, origin }) => {
            switch (origin) {
                case ORIGIN_TWITTER:
                    return getters[GETTERS.USER_BY_UUID](TWITTER_UUID);
                case ORIGIN_INSTAGRAM:
                    return getters[GETTERS.USER_BY_UUID](INSTAGRAM_UUID);
                default:
                    return getters[GETTERS.USER_BY_UUID](actor_uuid) || getters[GETTERS.USER_BY_UUID](ZERO_UUID);
            }
        };
    },
};
